
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/outreach",
      function () {
        return require("private-next-pages/destinations/outreach.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/outreach"])
      });
    }
  